/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React from "react";

const LoaderOverlay = props => {
  return (
      <div className="loader-overlay-container">
         <span className="spinning-loader"></span>
      </div>
  );
};

export default LoaderOverlay;
